import intersection from 'lodash/intersection';

import MainStorage from '@/storage/main';

import { LOCALES } from './index';

const getUserLocale = function(): string | undefined {
  const { language } = window.navigator;

  if (!language) {
    return;
  }

  const locale = language.split('-')[0];

  if (!LOCALES.includes(locale)) {
    return;
  }

  return locale;
};

const getUserPreferredLocale = function(): string | undefined {
  const { languages } = window.navigator;

  const common = intersection(languages, LOCALES);

  return common[0];
};

const determineLocale = function(): string | undefined {
  return getUserLocale() || getUserPreferredLocale();
};

const getLocale = function() {
  const locale = MainStorage.getLocale() || determineLocale();

  if (!locale) {
    return;
  }

  MainStorage.saveLocale(locale);

  return locale;
};

export { getUserLocale, getUserPreferredLocale, determineLocale, getLocale };
